import React from "react";
import PageHeader from "../../PageHeader";
import { ReactComponent as ExamIcon } from "../../../images/examimage/examicon.svg";
import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import useStyles from "../../../../styles";
import ViewFeedback from "./ViewFeedback";
import { toast } from "react-toastify";
import FeedBackExamInBulk from "../../../../BulkCSVFilder/FeedBackExamInBulk.csv"

function Feedback() {
  const classes = useStyles();
    const handleDownload = () => {
      const link = document.createElement("a");
      link.href = FeedBackExamInBulk;
      link.setAttribute("download", "FeedbackInBulk.csv");
  
      // Append to the document and trigger the download
      document.body.appendChild(link);
      link.click();
  
      // Check if the download started (link exists in document)
      if (document.body.contains(link)) {
        toast.success("Sample file for Feedback in bulk has been downloaded");
      } else {
        toast.error("Failed to download the bulk feedback file. Please try again.");
      }
  
      // Clean up
      link.parentNode.removeChild(link);
    };
  const Heading = [
    {
      id: 1,
      pageicon: <ExamIcon />,
      mainheading: "Feedback",
      addbtntext: "Create New Feedback",
      onDownload: handleDownload,
      subhead: "Want to Add in Bulk ?",
      showDownloadButton: true,
      // downloadexam: "true",
      addbtnicon: <AddIcon />,
      addbtnstyle: "bluebtn",
      path: "/admin/addfeedback",
    },
  ];
  return (
    <div className={`${classes.p2} ${classes.pb0} ${classes.pt1}`}>
      <PageHeader Heading={Heading} />
      <ViewFeedback />
    </div>
  );
}
export default Feedback;
